"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("react-day-picker/lib/style.css");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var dropdownCaretOpen = require("../../../icons/caretUpTundora.svg");

var dropdownCaret = require("../../../icons/caretDownTundora.svg");

var dropdownCaretDisabled = require("../../../icons/caretDownTundoraDisabled.svg");

var check = require("../../../icons/checkThick-24-white.svg");

exports.labelStyles = function (hasError) {
  return hs_web_style_guide_1.css({
    color: hasError ? colors_1.burntSienna : colors_1.silverChalice,
    display: 'block',
    margin: '24px 0 8px',
    textTransform: 'uppercase'
  });
};

exports.errorStyles = hs_web_style_guide_1.css({
  color: colors_1.burntSienna,
  paddingTop: 4,
  paddingLeft: 2,
  display: 'block'
});

exports.sharedInputStyles = function (hasError) {
  return hs_web_style_guide_1.css({
    borderRadius: 5,
    padding: '13px 16px',
    fontSize: 16,
    color: colors_1.tundora,
    display: 'block',
    border: "1px solid " + (hasError === true ? colors_1.burntSienna : colors_1.carrarra),
    backgroundColor: 'white',
    ':focus': {
      border: "1px solid " + colors_1.comet,
      outline: 'none'
    }
  });
};

exports.inputStyles = function (hasError) {
  return hs_web_style_guide_1.css(exports.sharedInputStyles(hasError), {
    boxSizing: 'border-box',
    height: 48,
    width: '100%',
    '::placeholder': {
      color: colors_1.silverChalice
    },
    '[type=number]': {
      MozAppearance: 'textfield',
      '::-webkit-inner-spin-button, ::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0
      }
    }
  });
};

exports.selectStyles = function (hasError) {
  return hs_web_style_guide_1.css({
    appearance: 'none',
    backgroundImage: "url(" + dropdownCaret + ")",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '90% 50%',
    backgroundColor: colors_1.white,
    ':disabled': {
      color: colors_1.rgba(colors_1.tundora, 0.4),
      backgroundImage: "url(" + dropdownCaretDisabled + ")"
    },
    '.open': {
      backgroundImage: "url(" + dropdownCaretOpen + ")"
    }
  });
};

exports.selectInputStyles = function (hasError) {
  return hs_web_style_guide_1.css({
    width: '100%',
    borderWidth: '0 0 1px 0'
  });
};

exports.selectInputLabelStyles = hs_web_style_guide_1.css({
  position: 'absolute',
  color: colors_1.jaffa,
  right: '16px',
  top: '14px',
  backgroundColor: colors_1.white,
  ':hover': {
    ':not(:disabled)': {
      color: colors_1.tango,
      cursor: 'pointer'
    }
  }
});

exports.textAreaStyles = function (hasError) {
  return hs_web_style_guide_1.css(exports.sharedInputStyles(hasError), {
    resize: 'none',
    height: '144px',
    width: '100%'
  });
};

exports.listItemCardStyles = hs_web_style_guide_1.css({
  padding: '8px 18px',
  height: 48,
  fontSize: 16,
  color: colors_1.tundora,
  margin: 0
});

exports.listItemIconStyles = function (url) {
  return hs_web_style_guide_1.css({
    backgroundImage: "url(" + url + ")",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    backgroundColor: colors_1.white,
    height: '16px',
    width: '16px',
    ':hover': {
      cursor: 'pointer'
    }
  });
};

exports.dropdownDrawerStyles = hs_web_style_guide_1.css({
  zIndex: '1',
  position: 'absolute',
  backgroundColor: 'white',
  width: '100%',
  borderRadius: 5,
  border: "1px solid " + colors_1.carrarra,
  marginTop: '8px'
});
exports.reviewInputValueStyles = hs_web_style_guide_1.css({
  padding: 0,
  color: colors_1.tundora,
  border: 'none'
});
exports.reviewInputSubtextStyles = hs_web_style_guide_1.css({
  fontSize: '14px',
  lineHeight: '20px',
  color: colors_1.silverChalice
});
exports.width100Style = hs_web_style_guide_1.css({
  width: '100%',
  position: 'relative'
});

exports.hintTextStyles = function (side) {
  var margin;

  switch (side) {
    case 'left':
      margin = '0 8px 0 0';
      break;

    case 'right':
      margin = '0 0 0 8px';
      break;

    default:
      margin = '0 8px 0 8px';
  }

  return hs_web_style_guide_1.css({
    margin: margin,
    color: colors_1.comet
  });
};

exports.dayPickerInputStyle = hs_web_style_guide_1.css({
  '& .DayPickerInput': {
    width: '100%'
  }
});
exports.dayPickerStyle = hs_web_style_guide_1.css(font_1.uiRegularS, {
  borderRadius: '4px',
  border: "1px solid " + colors_1.carrarra,
  position: 'absolute',
  marginTop: '4px',
  backgroundColor: colors_1.white,
  '& .DayPicker-wrapper': {
    ':focus': {
      outline: 'none'
    }
  },
  '& .DayPicker-Month': {
    margin: '0 12px',
    borderCollapse: 'inherit'
  },
  '& .DayPicker-Weekdays': {
    color: colors_1.silverChalice,
    backgroundColor: colors_1.merino,
    fontSize: '12px'
  },
  '& .DayPicker-Day': {
    color: colors_1.tundora,
    fontSize: '12px',
    border: "1px solid " + colors_1.white,
    ':hover': {
      border: "1px solid " + colors_1.jaffa,
      color: colors_1.jaffa,
      backgroundColor: colors_1.white + " !important"
    }
  },
  '& .DayPicker-Day--outside': {
    color: colors_1.silverChalice,
    fontSize: '12px'
  },
  '& .DayPicker-Day--selected': {
    ':not(:hover)': {
      backgroundColor: colors_1.jaffa + " !important",
      color: colors_1.white
    }
  }
});
exports.dayPickerNavbarStyle = hs_web_style_guide_1.css({
  margin: '15px 28px 8px',
  lineHeight: '14px',
  color: colors_1.tundora,
  '& .isvg': {
    ':hover': {
      cursor: 'pointer'
    }
  }
});
exports.checkboxStyle = hs_web_style_guide_1.css(font_1.uiRegularS, {
  color: colors_1.tundora,
  justifyContent: 'flex-start',
  marginTop: '20px',
  lineHeight: '28px',
  '& .checkboxLabel': {
    marginLeft: '10px',
    color: colors_1.doveGrey,
    fontSize: '16px'
  },
  ':hover': {
    cursor: 'pointer'
  },
  '& .checkboxDisplay': {
    margin: '0',
    height: '16px',
    width: '16px',
    borderRadius: '2px',
    border: "2px solid " + colors_1.carrarra,
    '.checked': {
      borderColor: 'transparent',
      backgroundImage: "url(" + check + ")",
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundColor: colors_1.deYork
    }
  },
  '& input': {
    display: 'none'
  }
});

exports.inputOptions = function (options) {
  return hs_web_style_guide_1.css(__assign({}, options));
};